import React, { useEffect, useState } from 'react';
import { ErrorMessage, Formik } from 'formik';
import Swal from "sweetalert2";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Breadcrums from '../../../common/breadcrumbs';
import CustomCkeditor from '../../../common/customeditor';
import * as emailTemplateService from '../../../services/email.template';
import { SWAL_SETTINGS } from '../../../../../utils/Constants';
import { globalLoader, handleServerValidations } from '../../../../../utils/commonfunction';
import * as Yup from 'yup';
import { Tooltip, Whisper } from 'rsuite';
import { copyText } from '../../../../../utils/commonfunction';
import { useTranslation } from 'react-i18next';




const EmailTempEdit = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const [showdefault, setShowDefault] = useState({});
    const [dataLoaded, setDataLoaded] = useState(false);
    const [saveType, setSaveType] = useState('')
    const { t } = useTranslation()
    const breadcrumbs = [{ title: t("sidebar_link_dashboard"), url: "/dashboard" }, { title: t("automatic_emails"), url: "/admin/cms/default-email-template/list/1" }, { title: t("btn_edit"), url: "" }]


    const queryParams = new URLSearchParams(location.search);
    const devParam = queryParams.get('dev');
    const showAddButton = devParam === 'true';
    const [isDevMode, setIsDevMode] = useState(showAddButton);

    useEffect(() => {
        setIsDevMode(showAddButton);
    }, [showAddButton]);


    useEffect(() => {
        emailTemplateService.Details(params.id).then(response => {
            setShowDefault(response && response.data ? response.data : []);
            setTimeout(() => {
                setDataLoaded(true);
            }, 100);
        }).catch(error => {
            console.log("error=====>", error);
        });
    }, []);


    const validationSchema = Yup.object().shape({
        title: Yup.string().required(t("label_title_error")).max(90, t("max_length_label")).test('no-spaces', t("label_title_error"), (value) => value.trim()),
        slug: Yup.string().required(t("label_slug_error")).test('no-spaces', t("label_slug_error"), (value) => value.trim()),
        subject: Yup.string().required(t("label_subject_error")).max(90, t("max_length_label")).test('no-spaces', t("label_subject_error"), (value) => value.trim()),
        richtext: Yup.string().required(t("label_richtext_error")).test('no-spaces', t("label_richtext_error"), (value) => value.trim()),
    });

    const handleClick = (text) => {
        copyText(text);
        Swal.fire({
            icon: 'success',
            text: 'Copied',
            ...SWAL_SETTINGS,
        })
    }

    const addOption = (currentValue, setFieldValue) => {
        setFieldValue("options", [...currentValue, ""]);
    };
    const removeOption = (currentValue, index, setFieldValue) => {
        let options = [...currentValue];
        options.splice(index, 1);
        setFieldValue("options", options);
    };

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <Formik
                enableReinitialize
                initialValues={{
                    title: showdefault && showdefault.title ? showdefault.title : "",
                    title_de: showdefault && showdefault.title_de ? showdefault.title_de : "",
                    subject: showdefault && showdefault.subject ? showdefault.subject : "",
                    richtext: showdefault && showdefault.description ? showdefault.description : "",
                    options: showdefault && showdefault.options && showdefault.options?.length ? showdefault.options : [""],
                    slug: showdefault && showdefault.slug ? showdefault.slug : "",
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    globalLoader(true);
                    let formData = new FormData();
                    formData.append('o_id', params.id)
                    formData.append('title', values.title);
                    formData.append('title_de', values.title_de);
                    formData.append('subject', values.subject);
                    formData.append('description', values.richtext);

                    formData.append('slug', values.slug);
                    if (isDevMode) {
                        formData.append('options', JSON.stringify(values.options));
                    }
                    emailTemplateService.Edit(formData).then(response => {
                        setSubmitting(false);
                        if (response.success) {
                            Swal.fire({
                                icon: 'success',
                                text: response.message,
                                ...SWAL_SETTINGS
                            })
                            if (saveType !== 'Save') {
                                setTimeout(() => {
                                    navigate(`/admin/cms/default-email-template/list/${params.pgno}`)
                                }, 1000);
                            }
                            globalLoader(false);
                        } else {
                            Swal.fire({
                                icon: 'error',
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS
                            });
                            globalLoader(false);
                        }
                    }).catch(error => {
                        console.log("error ====> ", error);
                    })
                }}
            >{({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
                isSubmitting,

            }) => (
                <form onSubmit={handleSubmit}>
                    <div className="row row-sm">
                        <div className="col-lg-12 col-md-12 animation_fade">
                            <div className="card custom-card">
                                <div className="card-body">
                                    <div>
                                        <h6 className="main-content-label mb-3">{t("edit_automatic_email")}</h6>
                                    </div>
                                    <div className="row row-sm">
                                        <div className='col-md-6 text-center form-group'>
                                            <label htmlFor='title' className='text-left d-flex'>{t("title")}:<span className="requirestar">*</span> </label>
                                            <input name='title' id='title' type='text' onChange={handleChange} onBlur={handleBlur} value={values.title} className='form-control' />
                                            <span className='text-danger d-flex text-left'><ErrorMessage name={"title"} /></span>
                                        </div>
                                        {/* <div className='col-md-6 text-center form-group'>
                                            <label htmlFor='title_de' className='text-left d-flex'>Title In German:<span className="requirestar">*</span> </label>
                                            <input name='title_de' id='title_de' type='text' onChange={handleChange} onBlur={handleBlur} value={values.title_de} className='form-control' />
                                            <span className='text-danger d-flex text-left'><ErrorMessage name={"title_de"} /></span>
                                        </div> */}
                                        <div className='col-md-6 text-center form-group'>
                                            <label htmlFor='slug' className='text-left d-flex'>{t("label_slug")}:<span className="requirestar">*</span> </label>
                                            <input disabled name='slug' type='text' id="slug" onChange={handleChange} onBlur={handleBlur} value={values.slug} className='form-control' />
                                            <span className='text-danger d-flex text-left'><ErrorMessage name={"slug"} /></span>
                                        </div>
                                        <div className='col-md-12 text-center form-group'>
                                            <label htmlFor='subject' className='text-left d-flex'>{t("list_heading_subject")}:<span className="requirestar">*</span> </label>
                                            <input name='subject' type='text' id="subject" onChange={handleChange} onBlur={handleBlur} value={values.subject} className='form-control' />
                                            <span className='text-danger d-flex text-left'><ErrorMessage name={"subject"} /></span>
                                        </div>
                                        {
                                            values?.options && values?.options.length ?
                                                <>
                                                    <div className='col-12'>
                                                        <label htmlFor={"option" + (values?.options.length - 1)} className='text-left d-flex'>{t("label_dynamic_options")}<span className="text-warning ms-2">({t("click_to_copy")})</span>
                                                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>{t("short_code")}</Tooltip>}>
                                                                <span className='field-more-info mt-1 ms-1 cp'>?</span>
                                                            </Whisper></label>
                                                    </div>
                                                    <div className="col-lg-12 mb-2">
                                                        {values?.options && values?.options.filter((item) => item !== "").map((item, index) => (
                                                            <span onClick={() => handleClick('{' + item.toUpperCase() + '}')} key={index} className="badge badge-dark my-2 me-2 cp">{'{' + item.toUpperCase() + '}'}</span>
                                                        ))}
                                                        {isDevMode && (
                                                            <div className="d-flex flex-wrap mt-2">
                                                                {values?.options && values?.options.map((item, index) => (
                                                                    <div className="mb-3 d-flex align-items-center me-4" key={index}>
                                                                        <input name={"options[" + index + "]"} value={item} onChange={handleChange} onBlur={handleBlur} type="text" style={{ width: "150px" }} className="form-control input-sm" id={"option" + (index)} placeholder="New dynamic option" autoFocus={true} />
                                                                        {
                                                                            values?.options?.length > 1 ?
                                                                                <button className='btn btn-main-danger bg-secondary text-white btn-sm py-0 px-1 rounded-circle ms-2' type='button' onClick={() => removeOption(values?.options, index, setFieldValue)}><i className="ri-close-large-line"></i></button>
                                                                                : null
                                                                        }
                                                                        {
                                                                            index === values?.options?.length - 1 ?
                                                                                <button className='btn btn-main-primary signbtn btn-sm py-0 px-1 rounded-circle ms-2' type='button' onClick={() => addOption(values?.options, setFieldValue)}><i className="ri-add-large-line"></i></button>
                                                                                : null
                                                                        }
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                                : null
                                        }
                                        <div className='col-lg-12 text-center form-group'>
                                            <label htmlFor='subject' className='text-left d-flex'>{t("label_description")}
                                                :<span className="requirestar">*</span></label>
                                            {
                                                dataLoaded ?
                                                    <CustomCkeditor
                                                        fieldname={"richtext"}
                                                        setFieldValue={setFieldValue}
                                                        value={values.richtext}
                                                        setFieldTouched={setFieldTouched}
                                                    />
                                                    :
                                                    ""
                                            }
                                            <span className='text-danger d-flex text-left'>{errors.richtext && touched.richtext && errors.richtext}</span>
                                        </div>

                                        <div className="">
                                            <button onClick={() => { setSaveType('Save') }} className="btn btn-info mr-2" type="submit" >
                                                <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                {t("btn_save")}
                                            </button>
                                            <button onClick={() => { setSaveType('') }} className="btn btn-success mr-2" type="submit">
                                                <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                {t("btn_save_exit")}
                                            </button>
                                            <button className="btn ripple btn-secondary" type='button' onClick={() => navigate(-1)}>
                                                <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                {t("btn_cancel")}
                                            </button>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}
            </Formik>
        </>
    )
}

export default EmailTempEdit